import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body{
    font-family: 'Roboto', sans-serif;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'Roboto', sans-serif;
  }

  section {
    position: relative;
  }

  /* Section anchors: keep the heading below the sticky navbar (also used by the
     menu's smooth scroll, see ScrollSpyMenu). 94px / 63px = the navbar's height once it
     is sticky (desktop with the START FREE button / hamburger layout). */
  #banner_section, #audit_results, #live_demo, #how_it_works, #comparison, #savings_workspace,
  #service_costs, #cost_insights, #agentic_finops, #feature_section, #privacy,
  #case_studies, #testimonial_section, #plans, #pricing,
  #book_section, #try_free, #team, #faq_section, #footer {
    scroll-margin-top: 94px;
    @media (max-width: 1199px) {
      scroll-margin-top: 63px;
    }
  }
  /* these two ids sit on an inner block without section padding above the heading:
     add ~14px of air under the navbar */
  #pricing, #try_free {
    scroll-margin-top: 108px;
    @media (max-width: 1199px) {
      scroll-margin-top: 77px;
    }
  }

  .drawer-content-wrapper{
    @media (max-width: 767px) {
      width: 300px!important;
    }
    .drawer-content {
      padding: 60px;    
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      @media (max-width: 767px) {
        padding: 50px 40px 30px 40px;
      }
      .mobile_menu {
        margin-bottom: 40px;
        flex-grow: 1;
        @media (max-width: 767px) {
          margin-bottom: 30px;
        }
        li{
          margin-bottom: 35px;
          @media (max-width: 767px) {
            margin-bottom: 25px;
          }
          a{
            font-size: 20px;
            font-weight: 400;
            color: #343d48;
            position: relative;
            transition: 0.15s ease-in-out;
            @media (max-width: 767px) {
              font-size: 18px;
            }
            &:hover {
              color: #46679f;
            }
            &:before{
              content: '';
              width: 7px;
              height: 7px;
              background: #46679f;
              border-radius: 50%;
              position: absolute;
              top: 50%;
              left: -15px;
              transform: translateY(-50%);
              opacity: 0;
            }
          }
          &.is-current {
            a {
              color: #46679f;
              &:before{
                opacity: 1;
              }
            }
          }
        }
      }
      .navbar_drawer_button button{
        width: 100%;
      }
    }

    .reusecore-drawer__close{
      width: 34px;
      height: 34px;
      position: absolute;
      top: 20px;
      right: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      @media (max-width: 767px) {
        top: 15px;
        right: 15px;
      }
      &:before{
        content: '\f10b';
        font-family: Flaticon;
        font-size: 26px;
        color: #46679f;
        transform: rotate(45deg);
        display: block;
      }
    }
  }
`;

export const ContentWrapper = styled.div`
  overflow: hidden;
  .sticky-nav-active {
    .saas_navbar {
      background: #fff;
      box-shadow: 0px 3px 8px 0px rgba(43, 83, 135, 0.08);
      padding: 15px 0;
      .main-logo {
        display: none;
      }
      .logo-alt {
        display: block;
      }
      .main_menu {
        li {
          a {
            color: #000;
            &:hover {
              color: #46679f;
            }
          }
          &.is-current {
            a {
              color: #46679f;
            }
          }
        }
      }
    }
    .hamburgMenu__bar {
      > span {
        background: #46679f;
      }
    }
  }

  .saas_navbar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    transition: 0.35s ease-in-out;
    padding: 30px 0;
    .logo-alt {
      display: none;
    }
    .main_menu {
      margin-right: 24px;
      li {
        display: inline-block;
        padding-left: 11px;
        padding-right: 11px;
        &:first-child {
          padding-left: 0;
        }
        &:last-child {
          padding-right: 0;
        }
        &.is-current {
          a {
            color: #FDB32A;
          }
        }
        a {
          padding: 5px;
          font-size: 16px;
          font-weight: 400;
          color: #fff;
          transition: 0.15s ease-in-out;
          &:hover {
            color: #FDB32A;
          }
        }
      }
      /* Optional first word of a label ("Interactive Demo"): only on a wide page, so the
         menu stays on one line and never reaches the logo or START FREE. */
      .menu_label_prefix {
        @media (max-width: 1439px) {
          display: none;
        }
      }
      /* 1200-1259 px: the container is only 970 px wide, so keep the menu on one line
         (tighter gaps) instead of wrapping under the logo. */
      white-space: nowrap;
      @media (min-width: 1200px) and (max-width: 1259px) {
        margin-right: 16px;
        li {
          padding-left: 7px;
          padding-right: 7px;
          &:first-child {
            padding-left: 0;
          }
          &:last-child {
            padding-right: 0;
          }
        }
      }
      @media (max-width: 1199px) {
        display: none;
      }
    }
    .navbar_button {
      white-space: nowrap;
      flex-shrink: 0;
      @media (max-width: 1199px) {
        display: none;
      }
    }
    .reusecore-drawer__handler {
      @media (min-width: 1200px) {
        display: none !important;
      }
      .hamburgMenu__bar {
        > span {
        }
      }
    }
  }
`;
